import React from 'react'

export interface MenuShareAndCartProps {
	readonly shareLinkCopied: () => void
	readonly viewCart: (value: boolean) => void
}

export const MenuShareAndCart = (props: MenuShareAndCartProps) => {
	return (
		<>
			<div className='flex-shrink-0 flex border-t border-gray-200 p-4'>
				<button
					className='flex-shrink-0 w-full group block'
					id='share-config-button'
					data-clipboard-text="Just because you can doesn't mean you should — clipboard.js"
					onClick={() => props.shareLinkCopied()}>
					<div className='flex items-center text-sm font-medium text-gray-700 group-hover:text-gray-900'>
						<svg className='mr-3 flex-shrink-0 h-6 w-6' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z'
							/>
						</svg>
						<span>Share Your Configuration</span>
					</div>
				</button>
			</div>
			<div id='checkout-button' className='flex-shrink-0 flex border-t border-gray-200 p-4'>
				<a href='#' className='flex-shrink-0 w-full group block' onClick={() => props.viewCart(true)}>
					<div className='flex items-center text-sm font-medium text-gray-700 group-hover:text-gray-900'>
						<svg className='mr-3 flex-shrink-0 h-6 w-6' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z'></path>
						</svg>
						<span id='checkout-button-text'>View Cart</span>
					</div>
				</a>
			</div>
		</>
	)
}
